module.exports = __webpack_public_path__ + "static/media/screenshot.466661dc.png";